export const AD_TYPES = [
  { label: "Native Ad", value: "native" },
  { label: "Display Ad", value: "display" },
  { label: "Interactive Ad", value: "interactive" },
  { label: "Video Ad", value: "video" },
];

export const DISABLED_AD_TYPES = ["display", "interactive", "video"];
